/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_014: Question = {
  id: 'multi-014-potager-terrains-prives',
  oldId: '75',
  title: 'Absence de règlement défavorable à l\'aménagement de potager sur les terrains privés',
  number: '7.6',
  description: ['Absence de règlement défavorable à l\'aménagement de potager sur toute ou partie des terrains privés'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 10,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_multi_014__v3: Question = {
  ...question_multi_014,
  title: 'Adoption de réglements favorable à l’aménagement contrôlé de potagers sur terrains privés',
};

export const question_multi_014_v2: Question = question_multi_014;
export const question_multi_014_v3: Question = question_multi_014__v3;
